import { LogOut, History, Users, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { COMPANY } from "@/lib/pricing";
import { useAuth } from "@/context/AuthContext";

export default function AppHeader({ onOpenHistory, onOpenCarriers, onOpenAI }) {
  const { logout } = useAuth();
  return (
    <header className="sticky top-0 z-40 bg-white border-b border-border pt-[env(safe-area-inset-top)]">
      <div className="max-w-[1500px] mx-auto px-4 md:px-8 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <img
            src="/kg-logo.png"
            alt="K&G Mowers + Tractors"
            className="h-11 md:h-12 w-auto rounded-lg bg-[#1C1917] px-2 py-1 shrink-0"
            data-testid="app-logo"
          />
          <p className="hidden md:block text-xs text-[#57534E] truncate">
            {COMPANY.address} &middot; {COMPANY.phone}
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button
            size="sm"
            onClick={onOpenAI}
            className="bg-[#F97316] hover:bg-[#EA580C] text-white"
            data-testid="open-ai-chat-button"
          >
            <Sparkles className="h-4 w-4 sm:mr-1.5" />
            <span className="hidden sm:inline">Ask AI</span>
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={onOpenCarriers}
            className="hidden sm:flex border-[#1C1917]/20"
            data-testid="open-carriers-admin-button"
          >
            <Users className="h-4 w-4 mr-1.5" /> Carriers
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={onOpenHistory}
            className="border-[#1C1917]/20"
            data-testid="open-history-button"
          >
            <History className="h-4 w-4 sm:mr-1.5" />
            <span className="hidden sm:inline">Quotes</span>
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={logout}
            className="text-[#57534E]"
            data-testid="logout-button"
          >
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </header>
  );
}
